import React, { createContext, useContext, useState, useEffect, useMemo } from 'react';
import { groupsAPI } from '../services/api';
import { useAuth } from './AuthContext';

const GroupContext = createContext(null);

export const useGroup = () => {
  const context = useContext(GroupContext);
  return context;
};

export const GroupProvider = ({ children }) => {
  const { user, loading: authLoading } = useAuth();
  const [memberIds, setMemberIds] = useState(null);
  const [loading, setLoading] = useState(true);

  const isStaff = user && user.userlevel >= 100;

  useEffect(() => {
    if (!isStaff || authLoading) {
      setMemberIds(null);
      setLoading(false);
      return;
    }
    let cancelled = false;
    setLoading(true);
    groupsAPI
      .getMe()
      .then((res) => {
        if (cancelled) return;
        if (res.data.success && res.data.memberIds && res.data.memberIds.length > 0) {
          setMemberIds(res.data.memberIds);
        } else {
          setMemberIds(null);
        }
      })
      .catch(() => {
        if (!cancelled) setMemberIds(null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, [isStaff, authLoading, user?.id, user?.userId]);

  const value = useMemo(
    () => ({
      memberIds,
      loading,
      /** For script/log filtering: include scripts owned by any of these ids. If null, caller should use current user id only (staff) or all (admin). */
      scopeOwnerIds: memberIds && memberIds.length > 0 ? memberIds : null,
    }),
    [memberIds, loading]
  );

  return <GroupContext.Provider value={value}>{children}</GroupContext.Provider>;
};
